export default __webpack_public_path__ + "static/media/refresh.ff2040ab.svg";